import { createContext, useContext } from 'react'

interface ToastContextType {
  toastId: string
  close: () => void
}

export const ToastContext = createContext<ToastContextType | null>(null)

export function useToastContext() {
  const context = useContext(ToastContext)
  return context
}
